// extracted by mini-css-extract-plugin
export var link = "_ri-0";